export const SET_MP3PLAYER = 'SET_MP3PLAYER'
export const CLEAR_MP3PLAYER = 'CLEAR_MP3PLAYER'
export const CLEAR_LASTUPDATE = 'CLEAR_LASTUPDATE'
